












import { Component, Vue } from 'vue-property-decorator';

@Component({

})
export default class Home extends Vue {

  private mounted() {
    this.$nextTick(() => {
      this.initPlay();
    });
  }

  private currentTime: any = null;
  private currentVideoStatus = 0;
  private isShowStopPlay = false;
  private first = true;

  private rate = 0;
  private playBtn() {
    const video: any = document.getElementById('video2')
    video.play();
    this.first = false;
    this.currentVideoStatus = 1;
    this.currentTime = setInterval(()=>{
      const currentTime = video.currentTime;
      const duration = video.duration;
      this.rate = Math.min((currentTime / duration) * 100, 100);
    }, 1000);
  }

  private stopBtn() {
    const video: any = document.getElementById('video2')
    video.pause();
    this.isShowStopPlay = false;
    clearInterval(this.currentTime);
    this.currentVideoStatus = 0;
  }

  private videoClick() {
    if (this.currentVideoStatus) {
      this.isShowStopPlay = true;
      setTimeout(()=> {
        this.isShowStopPlay = false;
      }, 2000);
    }
  }

  private initPlay() {
    const video: any = document.querySelector("video");
    // this.renderCanvas();
    video.onended = ()=> {
      clearInterval(this.currentTime);
      this.currentVideoStatus = 0;
      this.isShowStopPlay = false;
      this.rate = 0;
      this.first = true;
    }
  }
}
